
const FeatureFlag = {
    ModoSteamHabilitado: true,
    DesabilitaConsumoTotalDePersonagensEContas: true,
    DesabilitaStatusJogo: true,
}

export {
    FeatureFlag
}